(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
import React from 'react';
import PropTypes from 'prop-types';
import './FormControl.scss';
import Wrapper from './Wrapper';
function Select({
  feedback = true,
  label,
  ...props
} = {}) {
  return /*#__PURE__*/React.createElement(Wrapper, {
    label: label
  }, /*#__PURE__*/React.createElement("select", _extends({}, props, {
    className: `form-control${props.className ? ` ${props.className}` : ''}`
  }), props.children), feedback && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "valid-feedback"
  }, "Looks good!"), /*#__PURE__*/React.createElement("div", {
    className: "invalid-feedback"
  }, "Please provide your ", label)));
}
Select.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.string,
  feedback: PropTypes.bool,
  onChange: PropTypes.func
};
const _default = Select;
export default _default;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(Select, "Select", "/var/www/html/websites/livecbm-com/src/frontend/components/custom/formControl/Select.jsx");
  reactHotLoader.register(_default, "default", "/var/www/html/websites/livecbm-com/src/frontend/components/custom/formControl/Select.jsx");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();